import { render } from "./AppToApp.vue?vue&type=template&id=561e6640"
import script from "./AppToApp.vue?vue&type=script&lang=js"
export * from "./AppToApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__